<!-- executive toggle -->
<button mat-icon-button [matMenuTriggerFor]="executiveActions" [matTooltip]="'Mi promotor'"  
[matTooltipPosition]="'below'">
  <mat-icon [svgIcon]="'heroicons_outline:briefcase'" ></mat-icon>
</button>
<mat-menu [xPosition]="'before'" #executiveActions="matMenu">
  <div class="row text-center ">
    <div class="col-12 text-base text-center text-bxBlue">Datos de tu promotor</div>
    <mat-divider class="mb-1"></mat-divider>
  </div>
  <button mat-menu-item class="h-8">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:briefcase'"></mat-icon>
    <span class=" text-base font-medium"> {{ dExecutive.promotor}}</span>
  </button>
  <button mat-menu-item class="h-8" *ngIf="dExecutive.correoPromotor?.length > 0">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
    <span class="text-base font-medium">{{ dExecutive.correoPromotor}}</span>
  </button>
  <button mat-menu-item class="h-8" *ngIf="dExecutive.telefonoPromotor?.length > 0">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:phone'"></mat-icon>
    <span class=" text-base font-medium">{{ dExecutive.telefonoPromotor}} </span>
  </button>
  <!-- <button mat-menu-item class="h-8" >
    <mat-icon class="icon-size-5 text-green-500" svgIcon="feather:message-square"></mat-icon>
    <span class=" text-base font-medium">Danos tu opnión</span>
  </button> -->
</mat-menu>